import { BrowserRouter } from "react-router-dom";

import { AppRoutes } from "./base/routes/appRoutes";
import BottomBar from "./base/components/BottomBar";
import { LeftMenu } from "./base/components/LeftMenu";
import { MobileMenu } from "./base/components/MobileMenu";

const App = () => {
  const pathName = window.location.pathname;
  return (
    <div className="container mx-auto h-screen">
      <BrowserRouter>
        <MobileMenu />
        <div className="flex flex-row sm:mt-28">
          {pathName !== "/admin" && <LeftMenu />}
          <AppRoutes />
        </div>
      </BrowserRouter>
       {pathName !== "/admin" && <BottomBar />}
    </div>
  );
};

export default App;
